import React from "react";
import { Card, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Header from "./header";
import Footer from "./footer";

export default function Frontend() {
  // Sample job openings data
  const jobOpenings = [
    {
      title: "Full Stack Ruby on Rails Developer",
      company: "RubyTech Innovations",
      location: "RubyCity, On-site",
      salary: "₹17L - ₹26L",
      description:
        "RubyTech Innovations is seeking a Full Stack Ruby on Rails Developer to contribute to the development of robust and scalable web applications. If you are passionate about Ruby and have expertise in full-stack development, apply now and be part of our dynamic team!",
    },
    {
      title: "Lead Full Stack Java Engineer",
      company: "JavaCraft Solutions",
      location: "JavaValley, Remote",
      salary: "₹22L - ₹32L",
      description:
        "JavaCraft Solutions is hiring a Lead Full Stack Java Engineer to lead the design and implementation of Java-based web applications. If you have a strong background in both frontend and backend Java development, join us in building cutting-edge solutions.",
    },
    {
      title: "Full Stack PHP Developer",
      company: "PHPGenius Tech",
      location: "PHPCity, On-site",
      salary: "₹15L - ₹22L",
      description:
        "PHPGenius Tech is looking for a Full Stack PHP Developer to create dynamic and efficient web applications. If you have expertise in both frontend and backend PHP development, apply now and be a part of our innovative team!",
    },
    {
      title: "Senior Full Stack .NET Developer",
      company: ".NET Dynamics",
      location: ".NETHub, Remote",
      salary: "₹23L - ₹35L",
      description:
        ".NET Dynamics is seeking a Senior Full Stack .NET Developer to lead the development of scalable and secure web applications. If you have a strong background in both frontend and backend .NET technologies, join us in pushing the boundaries of technology.",
    },
    {
      title: "Full Stack Angular Developer",
      company: "AngularCraft Innovations",
      location: "AngularValley, On-site",
      salary: "₹19L - ₹28L",
      description:
        "AngularCraft Innovations is in search of a Full Stack Angular Developer to contribute to the development of modern and responsive web applications. If you are passionate about Angular and have expertise in full-stack development, apply now and be part of our dynamic team!",
    },
    {
      title: "Lead Full Stack C# Engineer",
      company: "C#Tech Solutions",
      location: "C#City, Remote",
      salary: "₹25L - ₹38L",
      description:
        "C#Tech Solutions is hiring a Lead Full Stack C# Engineer to lead the design and implementation of C#-based web applications. If you have a strong background in both frontend and backend C# development, join us in building innovative solutions.",
    },
    {
      title: "Full Stack Vue.js Developer",
      company: "VueGenius Tech",
      location: "VueHub, On-site",
      salary: "₹18L - ₹26L",
      description:
        "VueGenius Tech is looking for a Full Stack Vue.js Developer to create dynamic and visually appealing web applications. If you have expertise in both frontend and backend Vue.js development, apply now and be a part of our creative team!",
    },
    {
      title: "Senior Full Stack Node.js Developer",
      company: "NodeCraft Innovations",
      location: "NodeHub, Remote",
      salary: "₹24L - ₹35L",
      description:
        "NodeCraft Innovations is seeking a Senior Full Stack Node.js Developer to lead the development of scalable and efficient web applications. If you have a strong background in both frontend and backend Node.js technologies, join us in shaping the future of web development.",
    },
    {
      title: "Full Stack React Developer",
      company: "ReactTech Dynamics",
      location: "ReactValley, On-site",
      salary: "₹20L - ₹28L",
      description:
        "ReactTech Dynamics is in search of a Full Stack React Developer to contribute to the development of modern and responsive web applications. If you are passionate about React.js and have expertise in full-stack development, apply now and be part of our dynamic team!",
    },
    {
      title: "Lead Full Stack PHP Engineer",
      company: "PHP Dynamics",
      location: "PHPHub, Remote",
      salary: "₹26L - ₹40L",
      description:
        "PHP Dynamics is hiring a Lead Full Stack PHP Engineer to lead the design and implementation of PHP-based web applications. If you have a strong background in both frontend and backend PHP development, join us in building innovative solutions.",
    },
    {
      title: "Full Stack Express.js Developer",
      company: "ExpressGenius Tech",
      location: "ExpressHub, On-site",
      salary: "₹17L - ₹25L",
      description:
        "ExpressGenius Tech is looking for a Full Stack Express.js Developer to create dynamic and efficient web applications. If you have expertise in both frontend and backend Express.js development, apply now and be a part of our innovative team!",
    },
    {
      title: "Senior Full Stack Python Developer",
      company: "PythonCraft Innovations",
      location: "PythonHub, Remote",
      salary: "₹26L - ₹38L",
      description:
        "PythonCraft Innovations is seeking a Senior Full Stack Python Developer to lead the development of scalable and efficient web applications. If you have a strong background in both frontend and backend Python technologies, join us in shaping the future of web development.",
    },
    {
      title: "Full Stack Laravel Developer",
      company: "LaravelTech Dynamics",
      location: "LaravelValley, On-site",
      salary: "₹19L - ₹27L",
      description:
        "LaravelTech Dynamics is in search of a Full Stack Laravel Developer to contribute to the development of robust and scalable web applications. If you are passionate about Laravel and have expertise in full-stack development, apply now and be part of our dynamic team!",
    },
    {
      title: "Lead Full Stack AngularJS Engineer",
      company: "AngularJSTech Solutions",
      location: "AngularJSHub, Remote",
      salary: "₹28L - ₹42L",
      description:
        "AngularJSTech Solutions is hiring a Lead Full Stack AngularJS Engineer to lead the design and implementation of AngularJS-based web applications. If you have a strong background in both frontend and backend AngularJS development, join us in building innovative solutions.",
    },
    {
      title: "Full Stack Ruby Developer",
      company: "RubyGenius Tech",
      location: "RubyHub, On-site",
      salary: "₹18L - ₹26L",
      description:
        "RubyGenius Tech is looking for a Full Stack Ruby Developer to create dynamic and visually appealing web applications. If you have expertise in both frontend and backend Ruby development, apply now and be a part of our creative team!",
    },
    {
      title: "Senior Full Stack ASP.NET Developer",
      company: "ASP.NET Dynamics",
      location: "ASP.NETHub, Remote",
      salary: "₹24L - ₹36L",
      description:
        "ASP.NET Dynamics is seeking a Senior Full Stack ASP.NET Developer to lead the development of scalable and secure web applications. If you have a strong background in both frontend and backend ASP.NET technologies, join us in pushing the boundaries of technology.",
    },
    {
      title: "Full Stack Django Developer",
      company: "DjangoCraft Innovations",
      location: "DjangoValley, On-site",
      salary: "₹20L - ₹28L",
      description:
        "DjangoCraft Innovations is in search of a Full Stack Django Developer to contribute to the development of robust and scalable web applications. If you are passionate about Django and have expertise in full-stack development, apply now and be part of our dynamic team!",
    },
    {
      title: "Lead Full Stack Vue.js Engineer",
      company: "VueJSTech Solutions",
      location: "VueJSHub, Remote",
      salary: "₹30L - ₹45L",
      description:
        "VueJSTech Solutions is hiring a Lead Full Stack Vue.js Engineer to lead the design and implementation of Vue.js-based web applications. If you have a strong background in both frontend and backend Vue.js development, join us in building innovative solutions.",
    },
    {
      title: "Full Stack MERN Developer",
      company: "MERNCraft Innovations",
      location: "MERNHub, On-site",
      salary: "₹22L - ₹32L",
      description:
        "MERNCraft Innovations is looking for a Full Stack MERN Developer to create dynamic and efficient web applications. If you have expertise in both frontend and backend MERN stack development, apply now and be a part of our innovative team!",
    },
    {
      title: "Full Stack .NET Core Developer",
      company: ".NETCore Innovations",
      location: ".NETCoreHub, Remote",
      salary: "₹25L - ₹35L",
      description:
        ".NETCore Innovations is seeking a Full Stack .NET Core Developer to contribute to the development of scalable and efficient web applications. If you are passionate about .NET Core and have expertise in full-stack development, apply now and be part of our dynamic team!",
    },
    {
      title: "Lead Full Stack Vue.js Developer",
      company: "VueJS Dynamics",
      location: "VueJSCity, On-site",
      salary: "₹28L - ₹40L",
      description:
        "VueJS Dynamics is hiring a Lead Full Stack Vue.js Developer to lead the design and implementation of Vue.js-based web applications. If you have a strong background in both frontend and backend Vue.js development, join us in building innovative solutions.",
    },
    {
      title: "Full Stack Spring Boot Developer",
      company: "SpringTech Innovations",
      location: "SpringHub, Remote",
      salary: "₹23L - ₹33L",
      description:
        "SpringTech Innovations is looking for a Full Stack Spring Boot Developer to create dynamic and efficient web applications. If you have expertise in both frontend and backend Spring Boot development, apply now and be a part of our innovative team!",
    },
    {
      title: "Senior Full Stack Angular Developer",
      company: "AngularGenius Tech",
      location: "AngularCity, On-site",
      salary: "₹26L - ₹38L",
      description:
        "AngularGenius Tech is seeking a Senior Full Stack Angular Developer to lead the development of scalable and efficient web applications. If you have a strong background in both frontend and backend Angular technologies, join us in shaping the future of web development.",
    },
    {
      title: "Full Stack Django REST Developer",
      company: "DjangoRESTCraft Innovations",
      location: "DjangoRESTHub, Remote",
      salary: "₹20L - ₹30L",
      description:
        "DjangoRESTCraft Innovations is in search of a Full Stack Django REST Developer to contribute to the development of robust and scalable web applications. If you are passionate about Django REST framework and have expertise in full-stack development, apply now and be part of our dynamic team!",
    },
    {
      title: "Lead Full Stack React.js Engineer",
      company: "ReactJSTech Solutions",
      location: "ReactJSHub, On-site",
      salary: "₹30L - ₹45L",
      description:
        "ReactJSTech Solutions is hiring a Lead Full Stack React.js Engineer to lead the design and implementation of React.js-based web applications. If you have a strong background in both frontend and backend React.js development, join us in building innovative solutions.",
    },
    {
      title: "Full Stack Kotlin Developer",
      company: "KotlinGenius Tech",
      location: "KotlinCity, Remote",
      salary: "₹22L - ₹32L",
      description:
        "KotlinGenius Tech is looking for a Full Stack Kotlin Developer to create dynamic and visually appealing web applications. If you have expertise in both frontend and backend Kotlin development, apply now and be a part of our creative team!",
    },
    {
      title: "Senior Full Stack Express.js Developer",
      company: "ExpressJSCraft Innovations",
      location: "ExpressJSValley, On-site",
      salary: "₹28L - ₹40L",
      description:
        "ExpressJSCraft Innovations is seeking a Senior Full Stack Express.js Developer to lead the development of scalable and efficient web applications. If you have a strong background in both frontend and backend Express.js development, join us in shaping the future of web development.",
    },
    {
      title: "Full Stack TypeScript Developer",
      company: "TypeScriptTech Dynamics",
      location: "TypeScriptHub, Remote",
      salary: "₹25L - ₹35L",
      description:
        "TypeScriptTech Dynamics is seeking a Full Stack TypeScript Developer to contribute to the development of modern and scalable web applications. If you are passionate about TypeScript and have expertise in full-stack development, apply now and be part of our dynamic team!",
    },
    {
      title: "Lead Full Stack Flask Engineer",
      company: "FlaskJSTech Solutions",
      location: "FlaskJSCity, On-site",
      salary: "₹32L - ₹48L",
      description:
        "FlaskJSTech Solutions is hiring a Lead Full Stack Flask Engineer to lead the design and implementation of Flask-based web applications. If you have a strong background in both frontend and backend Flask development, join us in building innovative solutions.",
    },
    {
      title: "Full Stack Meteor Developer",
      company: "MeteorGenius Tech",
      location: "MeteorCity, Remote",
      salary: "₹21L - ₹30L",
      description:
        "MeteorGenius Tech is looking for a Full Stack Meteor Developer to create dynamic and efficient web applications. If you have expertise in both frontend and backend Meteor development, apply now and be a part of our innovative team!",
    },
    {
      title: "Senior Full Stack PHP Developer",
      company: "PHPGenius Dynamics",
      location: "PHPGeniusValley, On-site",
      salary: "₹30L - ₹42L",
      description:
        "PHPGenius Dynamics is seeking a Senior Full Stack PHP Developer to lead the development of scalable and efficient web applications. If you have a strong background in both frontend and backend PHP development, join us in shaping the future of web development.",
    },
    {
      title: "Full Stack Ember.js Developer",
      company: "EmberJSTech Innovations",
      location: "EmberJSValley, Remote",
      salary: "₹23L - ₹34L",
      description:
        "EmberJSTech Innovations is in search of a Full Stack Ember.js Developer to contribute to the development of modern and scalable web applications. If you are passionate about Ember.js and have expertise in full-stack development, apply now and be part of our dynamic team!",
    },
    {
      title: "Lead Full Stack MEAN Developer",
      company: "MEANGenius Tech",
      location: "MEANHub, On-site",
      salary: "₹35L - ₹50L",
      description:
        "MEANGenius Tech is hiring a Lead Full Stack MEAN Developer to lead the design and implementation of MEAN stack-based web applications. If you have a strong background in both frontend and backend MEAN development, join us in building innovative solutions.",
    },
    {
      title: "Full Stack Go Developer",
      company: "GoTech Dynamics",
      location: "GoCity, Remote",
      salary: "₹24L - ₹36L",
      description:
        "GoTech Dynamics is looking for a Full Stack Go Developer to create dynamic and visually appealing web applications. If you have expertise in both frontend and backend Go development, apply now and be a part of our creative team!",
    },
    {
      title: "Senior Full Stack Ruby on Rails Developer",
      company: "RubyonRailsGenius Tech",
      location: "RubyonRailsCity, On-site",
      salary: "₹32L - ₹45L",
      description:
        "RubyonRailsGenius Tech is seeking a Senior Full Stack Ruby on Rails Developer to lead the development of scalable and efficient web applications. If you have a strong background in both frontend and backend Ruby on Rails technologies, join us in shaping the future of web development.",
    },
    {
      title: "Full Stack Scala Developer",
      company: "ScalaCraft Innovations",
      location: "ScalaHub, Remote",
      salary: "₹26L - ₹38L",
      description:
        "ScalaCraft Innovations is seeking a Full Stack Scala Developer to contribute to the development of modern and scalable web applications. If you are passionate about Scala and have expertise in full-stack development, apply now and be part of our dynamic team!",
    },
    {
      title: "Lead Full Stack ASP.NET Core Engineer",
      company: "ASP.NETCore Tech Solutions",
      location: "ASP.NETCoreHub, On-site",
      salary: "₹38L - ₹55L",
      description:
        "ASP.NETCore Tech Solutions is hiring a Lead Full Stack ASP.NET Core Engineer to lead the design and implementation of ASP.NET Core-based web applications. If you have a strong background in both frontend and backend ASP.NET Core development, join us in building innovative solutions.",
    },
    {
      title: "Full Stack Swift Developer",
      company: "SwiftTech Dynamics",
      location: "SwiftCity, Remote",
      salary: "₹27L - ₹40L",
      description:
        "SwiftTech Dynamics is looking for a Full Stack Swift Developer to create dynamic and efficient web applications. If you have expertise in both frontend and backend Swift development, apply now and be a part of our creative team!",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Full Stack Developer Jobs 2025</title>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="description"
          content="Explore the latest remote full stack developer job opportunities with leading companies in 2025."
        />
        <meta
          name="keywords"
          content="full stack developer, remote jobs, web development, React, Node.js, JavaScript"
        />
        <meta name="author" content="Your Name" />
        {/* Add more meta tags as needed */}
      </Helmet>

      <Header />
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 mb-12 text-center">
            <h1 className="font-weight-bold">Full Stack Developer Jobs 2025</h1>
            <p className="lead">
              Explore exciting remote opportunities in Full Stack development
              with leading companies.
            </p>
          </div>
          {jobOpenings.map((job, index) => (
            <div key={index} className="col-md-12 mb-12">
              <Card>
                <Card.Body>
                  <Card.Title>{job.title}</Card.Title>
                  <Card.Text>{job.salary}</Card.Text>
                  <Card.Subtitle className="mb-12 text-muted">
                    {job.company} - {job.location}
                  </Card.Subtitle>
                  <Card.Text>{job.description}</Card.Text>
                  <div className="d-flex justify-content-between align-items-center">
                    <Button variant="primary">Apply Now</Button>
                    <span>Today</span>
                  </div>
                </Card.Body>
              </Card>{" "}
              <br />
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
